'use strict';

// Constructor
var SearchInPageSearch = function() {
  $('#in-page-search-block-form').attr('role', 'search');
};

module.exports = SearchInPageSearch;
